<template>
    <SoliResponsiveDialog
        ref="dialog"
        :mobile-scroll="false"
        title="New Relationship"
        @reset="$emit('reset')"
    >
        <template #subtitle>{{ subtitle }}</template>
        <template #body>
            <v-container>
                <v-form @submit.prevent="submit" v-model="valid" ref="form">
                    <div class="flex flex-col gap-4">
                        <v-row
                            no-gutters
                            class="w-full"
                            :class="{ 'gap-4': $vuetify.breakpoint.xs }"
                        >
                            <v-col
                                cols="12"
                                sm="6"
                                :class="{
                                    'pr-2': $vuetify.breakpoint.smAndUp,
                                }"
                            >
                                <SoliText
                                    v-model="form.first_name"
                                    icon="person"
                                    label="First Name"
                                    :rules="rules_required"
                                    hideDetails="auto"
                                    :error="errors?.first_name"
                            /></v-col>
                            <v-col
                                cols="12"
                                sm="6"
                                :class="{
                                    'pl-2': $vuetify.breakpoint.smAndUp,
                                }"
                            >
                                <SoliText
                                    v-model="form.last_name"
                                    icon="people"
                                    label="Last Name"
                                    :rules="rules_required"
                                    hideDetails="auto"
                                    :error="errors?.last_name"
                                /> </v-col
                        ></v-row>
                        <SoliBirthday
                            v-model="form.birthday"
                            :min="minDate"
                            :max="maxDate"
                            label="Birthday"
                            required
                            hide-details="auto"
                        ></SoliBirthday>
                        <v-select
                            :items="relationshipOptions"
                            item-text="relation"
                            label="Relationship"
                            return-object
                            v-model="form.relation"
                            outlined
                            dense
                            :rules="rules_select"
                            prepend-inner-icon="handshake"
                        >
                        </v-select>
                        <SoliBtn
                            text="Add Relationship"
                            icon="person_add"
                            block
                            gradient="gradient-blue"
                            :loading="loading"
                            type="submit"
                        />
                    </div>
                </v-form>
            </v-container>
        </template>
    </SoliResponsiveDialog>
</template>

<script>
import FormRules from "../../Mixins/FormRules";
import GlobalMoment from "../../Mixins/GlobalMoment";
import SoliResponsiveDialog from "../Base/SoliResponsiveDialog.vue";

export default {
    props: {
        guest: {},
        user: {},
        relationships: {},
        errors: {},
        subtitle: {
            type: String,
            default: "",
        },
        minAge: {
            type: Number,
            default: 0,
        },
        maxAge: {
            type: Number,
            default: 120,
        },
    },
    mixins: [FormRules],
    data() {
        return {
            valid: false,
            loading: false,
            form: this.$inertia.form({
                first_name: null,
                last_name: null,
                birthday: null,
                relation: null,
                guest_session_id: this.guest?.id ?? null,
                //start user relation hack
                existingUser: false,
                email_updates: true,
                loginable: false,
                parent_id: this.user?.id ?? null,
                email: null,
                user_id: null,
            }),
            relationshipOptions: [
                {
                    inverse: "Parent",
                    relation: "Child",
                },
                {
                    inverse: "Child",
                    relation: "Parent",
                },
                {
                    inverse: "Grandchild",
                    relation: "Grandparent",
                },
                {
                    inverse: "Grandparent",
                    relation: "Grandchild",
                },
                {
                    inverse: "Sibling",
                    relation: "Sibling",
                },
                {
                    inverse: "Friend",
                    relation: "Friend",
                },
                {
                    inverse: "Spouse",
                    relation: "Spouse",
                },
                {
                    inverse: "Other",
                    relation: "Other",
                },
            ],
        };
    },
    methods: {
        submit() {
            if (!this.$refs.form.validate()) return;
            this.loading = true;

            const postUrl = this.user
                ? route("relationUsers.store")
                : route("guestSessionChild.store");

            this.form
                .transform((data) => ({
                    ...data,
                    relation: this.form.relation.inverse,
                    inverse: this.form.relation.relation,
                }))
                .post(postUrl, {
                    preserveState: true,
                    preserveScroll: true,
                    onSuccess: () => {
                        this.$refs.dialog.show = false;
                        this.$emit("success");
                        this.loading = false;
                    },
                    onError: (errors) => {
                        this.loading = false;
                        console.log(
                            "This form returned errors:" +
                                JSON.stringify(errors)
                        );
                    },
                });
        },
    },
    computed: {
        minDate() {
            console.log(this.maxAge, this.minAge);
            return moment()
                .subtract(this.maxAge, "years")
                .toISOString()
                .slice(0, 10); // 'YYYY-MM-DD'
        },
        maxDate() {
            return moment()
                .subtract(this.minAge, "years")
                .toISOString()
                .slice(0, 10); // 'YYYY-MM-DD'
        },
    },
};
</script>
